var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup19270(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.572,
    height: 20.719,
    viewBox: "0 0 28.572 20.719",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_19270",
    "data-name": "Group 19270",
    transform: "translate(0.5 1.746)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10398",
    "data-name": "Path 10398",
    d: "M20746.777,21473.238l-14.117-8.359v7.141l-11.955-7.141v17.229l11.955-7.465v7.465Z",
    transform: "translate(-20720.705 -21464.879)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10401",
    "data-name": "Path 10401",
    d: "M717.489,764.96v16.719",
    transform: "translate(-691.417 -764.706)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup19270);
export default __webpack_public_path__ + "static/media/Group 19270.1285aecae8fb9bce3adf197880b75ab0.svg";
export { ForwardRef as ReactComponent };